export default {
  'Button.pleaseWait': 'Loading...',

  'Notifications.hide': 'Hide this message',

  'Login.email': 'Email',
  'Login.password': 'Password',
  'Login.otpCode': 'Authentication code',
  'Login.submit': 'Log in',
  'Login.invalidCredentials': 'Invalid credentials',
  'Login.wpLoginRateLimitReached': 'Too many login attempts. Please try later.',
  'Login.resetPassword': 'Forgot password?',
  'Login.success': 'Welcome!',
  'Login.backToLogin': 'Go back to Log in page',
  'Login.register': 'Sign up',
  'Login.haveAccount': 'Don\'t have an account?',

  'WpLogin.username': 'Username or Email Address',
  'WpLogin.password': 'Password',
  'WpLogin.success': 'Valid credentials! Loading WordPress, please wait...',

  'RequestPasswordReset.submit': 'Reset my password',
  'RequestPasswordReset.success': 'Email with instructions sent',

  'ResetPassword.submit': 'Reset Password',
  'ResetPassword.success': 'Password saved succesfully!',
  'SetPassword.submit': 'Activate account',
  'SetPassword.success': 'Account activated',

  'Logout.success': 'Logged out succesfully!',

  'Register.name': 'Your name',
  'Register.email': 'Company email (not @gmail)',
  'Register.password': 'Password',
  // 'Register.submit': 'Sign up',
  'Register.submit': 'Request access',
  'Register.login': 'Log in',
  'Register.success': 'Welcome!',
  'Register.confirmationSent': 'Thanks for your interest on HardyPress!',

  'ImportFtpSite.url': 'URL of the WordPress website to import',
  'ImportFtpSite.ftpHost': 'Host',
  'ImportFtpSite.ftpPassword': 'Password',
  'ImportFtpSite.ftpUsername': 'Username',
  'ImportFtpSite.ftpPort': 'Port',
  'ImportFtpSite.ftpFolder': 'Path',
  'ImportFtpSite.protocol': 'Protocol',
  'ImportFtpSite.submit': 'Proceed with the import',
  'ImportFtpSite.success': 'WordPress import in progress',
  'ImportFtpSite.error': 'Invalid credentials or WordPress not found',

  'ImportWpressSite.submit': 'Proceed with the import',
  'ImportWpressSite.success': 'WordPress import in progress',
  'ImportWpressSite.error': 'Invalid URL provided',
  'ImportWpressSite.wpressUrl': 'Paste here the URL of the archive file (max. 2GB)',

  'CreateSite.name': 'Site name',
  'CreateSite.wpUsername': 'Username',
  'CreateSite.wpEmail': 'Email',
  'CreateSite.wpPassword': 'Password',
  'CreateSite.submit': 'Install WordPress',
  'CreateSite.error': 'Invalid fields',
  'CreateSite.success': 'Site created',

  'Site.cloneFailure': 'Plan limits reached. Please upgrade to a bigger plan!',
  'Site.cloneSuccessful': 'Site cloned!',

  'ConfirmAccount.submit': 'Welcome!',
  'ConfirmAccount.success': 'Welcome!',

  'Settings.name': 'Name',
  'Settings.phpVersion': 'PHP version',
  'Settings.basicAuthEnabled': 'Enable the HTTP Basic-Auth',
  'Settings.additionalFiles': 'Manually add files to be included in the static version (one for line)',
  'Settings.excludedFiles': 'Manually add files to be excluded from the static version (one for line)',
  'Settings.errorPage': 'Custom 404 error page',
  'Settings.cf7CustomSender': 'Custom sender address',
  'Settings.zapierApiKey': 'Zapier API key',
  'Settings.smtpAddress': 'Address',
  'Settings.smtpPort': 'Port',
  'Settings.smtpDomain': 'Domain (HELO)',
  'Settings.smtpUserName': 'Username',
  'Settings.smtpPassword': 'Password',
  'Settings.smtpAuthentication': 'Authentication',
  'Settings.smtpOpensslVerifyMode': 'OpenSSL verify mode',
  'Settings.smtpEnableStarttlsAuto': 'Enable StartTLS Auto',
  'Settings.cacheExpirationTime': 'Leverage browser caching',
  'Settings.maxAgeHtml': '*.html, *.xml, *.php',
  'Settings.maxAgeCss': '*.css',
  'Settings.maxAgeJs': '*.js',
  'Settings.maxAgeImages': '*.jpg, *.jpeg, *.png, *.gif, *.webp, *.svg',
  'Settings.maxAgeOther': 'Others (*.eot, *.woff2, etc)',
  'Settings.modPagespeedRewriteLevel': 'Pagespeed rewrite level',
  'Settings.smtpSsl': 'SSL',
  'Settings.smtpTls': 'TLS',
  'Settings.submit': 'Save',
  'Settings.submitOff': 'You need to switch WordPress OFF to save the settings',

  'Settings.error': 'Invalid fields',

  'Password.tooShort': 'Password too short',

  'CustomDomain.customDomain': 'Custom domain',
  'CustomDomain.submit': 'Submit',

  'EditAccount.billingInfo': 'Billig Info',
  'EditAccount.name': 'Name',
  'EditAccount.email': 'Email',
  'EditAccount.password': 'Password (leave blank if you don\'t want to change)',
  'EditAccount.submit': 'Submit',
  'EditAccount.success': 'Account updated',

  'Enable2FA.otp': 'Enter the code from the two-factor app on your mobile device.',
  'Disable2FA.otp': 'Enter the code from the two-factor app on your mobile device.',

  'BillingInfo.error': 'Invalid fields',
  'BillingInfo.success': 'Billing profile updated',
  'UpdateBillingProfile.submit': 'Save',
  'ResetPassword.password': 'Choose your new password',

  'EditAccount.error': 'Invalid fields',

  'EnableSsl.submit': 'Enable SSL',
  'DisableSsl.submit': 'Disable SSL',

  'Modal.close': 'Close',

  'Plugin.in_review': 'In review',
  'Plugin.compatible': 'Compatible',
  'Plugin.incompatible': 'Incompatible',
  'Plugin.useless': 'Useless',
  'Plugin.partially_compatible': 'Partially compatible',
  'Plugin.must_be_deactivated': 'Automatically deactivated',
  'Plugin.unknown': 'Unknown',


  'error.INVALID_FTP_CREDENTIALS': 'Invalid credentials or WordPress not found',
  'error.INVALID_CREDENTIALS': 'Invalid credentials',
  'error.BILLING_PROFILE_NEEDED': 'Before changing plan you need to add valid billing info!',
  'error.CREDIT_CARD_NEEDED': 'Before changing plan you need to add a valid credit card!',
  'error.PLAN_LIMITS_REACHED': 'Sorry, but you\'ve passed your plan limits: deploys are temporarly disabled',
  'error.INVALID_RECAPTCHA': 'Sorry, but it seems that you\'re not a human... if you encounter this message, contact us at support@hardypress.com',
  'error.DEPLOY_UNAVAILABLE': 'Sorry, but is not possibile to restore this deploy. Contact support to proceed.',
  'error.BACKUP_UNAVAILABLE': 'Sorry, but is not possibile to restore this backup. Contact support to proceed.',
  'error.DOWNLOAD_UNAVAILABLE': 'Sorry, but is not possibile to download this file. Contact support to proceed.',
  'error.MAX_ACTIVE_CONTAINERS_LIMITS_REACHED': 'Too many active containers for your account.',
  'error.STRIPE_INVALID_NUMBER': 'The card number is not a valid credit card number.',
  'error.STRIPE_INVALID_EXPIRY_MONTH': 'The card\'s expiration month is invalid.',
  'error.STRIPE_INVALID_EXPIRY_YEAR': 'The card\'s expiration year is invalid.',
  'error.STRIPE_INVALID_CVC': 'The card\'s security code is invalid.',
  'error.STRIPE_INVALID_SWIPE_DATA': 'The card\'s swipe data is invalid.',
  'error.STRIPE_INCORRECT_NUMBER': 'The card number is incorrect.',
  'error.STRIPE_EXPIRED_CARD': 'The card has expired.',
  'error.STRIPE_INCORRECT_CVC': 'The card\'s security code is incorrect.',
  'error.STRIPE_INCORRECT_ZIP': 'The card\'s zip code failed validation.',
  'error.STRIPE_CARD_DECLINED': 'The card was declined.',
  'error.STRIPE_MISSING': 'There is no card on a customer that is being charged.',
  'error.STRIPE_PROCESSING_ERROR': 'An error occurred while processing the card.',
  'error.ACCEPTED': 'must be accepted',
  'error.BLANK': 'can\'t be blank',
  'error.CNAME_NOT_PRESENT': 'CNAME pointing to cdn.hardypress.com not detected. Remember to temporarily disable Cloudflare or any other "proxy", if you use it, for our check to work.',
  'error.INVALID_DOMAIN': 'Invalid domain name',
  'error.CDN_INVALID_DOMAIN': 'You have to point your CNAME to cdn.hardypress.com and write here your domain',
  'error.PRESENT': 'must be blank',
  'error.CONFIRMATION': 'don\'t match with {attribute}',
  'error.EMPTY': 'can\t be empty',
  'error.EQUAL_TO': 'must be equal to {count}',
  'error.EVEN': 'deve essere pari',
  'error.EXCLUSION': 'è riservato',
  'error.GREATER_THAN': 'deve essere maggiore di {count}',
  'error.GREATER_THAN_OR_EQUAL_TO': 'deve essere maggiore o uguale a {count}',
  'error.INCLUSION': 'non è compreso tra le opzioni disponibili',
  'error.INVALID': 'invalid',
  'error.LESS_THAN': 'must be less than {count}',
  'error.LESS_THAN_OR_EQUAL_TO': 'deve essere minore o uguale a {count}',
  'error.NOT_A_NUMBER': 'is not a number',
  'error.NOT_AN_INTEGER': 'is not an integer',
  'error.ODD': 'deve essere dispari',
  'error.REQUIRED': 'is required',
  'error.TAKEN': 'already taken',
  'error.TOO_LONG': 'too long (maximum is {count} {count, plural, one {character} other {characters}})',
  'error.TOO_SHORT': 'too short (minimum is {count} {count, plural, one {character} other {characters}})',
  'error.WRONG_LENGTH': 'wrong length (must be {count} {count, plural, one {character} other {characters}})',
  'error.OTHER_THAN': 'must be other than %{count}',
  'error.WP_MUST_BE_PAUSED_TO_CHANGE_BACKUPS_ADDON': 'You must switch WordPress OFF to enable/disable the BACKUPS addon',
  'error.MUST_BE_1_WORD': 'must be 1 word',
  'error.MUST_START_WITH_SLASH': 'Must start with /',
  'error.HOSTNAME_ALREADY_REGISTERED': 'Hostname already registered or invalid',
  'error.TIME_LIMITS_REACHED': 'User unable to create new sites. Please try again in 30 minutes.',
  'error.FILE_TO_BIG': 'Archive size too large. Please contact support.',
  'error.INVALID_OTP': 'Invalid OTP code',

  'ChangeSitePlan.isBilledAnnually': 'Bill annually (20% discount)',
  'ChangeSitePlan.submit': 'Save',
  'ChangeSitePlan.billingProfile': 'Bill using this profile',
  'ChangeSitePlan.addons': 'Addons',
  'ChangeSitePlan.error': 'Invalid fields',
  'ChangeSitePlan.success': 'Addons updated',

  'Addon.backups.name': 'Backups',
  'Addon.backups.description': 'A backup is automatically created every time WordPress is switched OFF. Enable this addon to retain up to 25 backups',
  'Addon.custom-domain.name': 'Custom domain',
  'Addon.custom-domain.description': 'To use a custom domain, you’ll need to point the DNS records for the domain at our servers by creating a CNAME record in your DNS configuration that point to cdn.hardypress.com',

  'CreateBillingProfile.cardNumber': 'Card number (Visa, Mastercard or American Card)',
  'CreateBillingProfile.expiryDate': 'Card expiry date',
  'CreateBillingProfile.cvc': 'Card CVC code',
  'CreateBillingProfile.firstName': 'First name',
  'CreateBillingProfile.lastName': 'Last name',
  'CreateBillingProfile.email': 'Email (will be used to send invoices)',
  'CreateBillingProfile.country': 'Country',
  'CreateBillingProfile.city': 'City',
  'CreateBillingProfile.state': 'State',
  'CreateBillingProfile.zip': 'ZIP code',
  'CreateBillingProfile.addressLine': 'Address',
  'CreateBillingProfile.company': 'Company',
  'CreateBillingProfile.vatNumber': 'VAT number',
  'CreateBillingProfile.submit': 'Create billing profile',
  'CreateBillingProfile.success': 'Billing profile created',
  'CreateBillingProfile.error': 'Invalid fields',
  'CreateBillingProfile.destroySuccessful': 'Billing profile deleted',
  'deployState.in_progress': 'Building',
  'deployState.completed': 'Completed',
  'deployState.publishing': 'Publishing',
  'deployState.creating_backup': 'Completed',
  'deployState.cancelled': 'Cancelled',
  'deployState.failed': 'Failed',

  'creditCard.visa': 'Visa',
  'creditCard.mastercard': 'Mastercard',
  'creditCard.american express': 'American Express',
  'Site.resetSuccessful': 'Reset completed',
  'Site.reactivationSuccessful': 'Reactivation completed',
  'Site.destroySuccessful': 'Site deleted',
  'Settings.success': 'Settings saved',
  'CacheSettings.success': 'Cache settings saved. The changes will be applied on the next deploy.',
  'ServerSettings.success': 'Server settings saved. Restart your WordPress and generate a new deploy for the changes to take effect.',
  'ErrorPageSettings.success': 'Settings saved. You may need to generate a new deploy.',

  'CustomDomain.error': 'Invalid fields',
  'CustomDomain.success': 'Custom domain saved',
  'error.pullzone.hostname_invalid': 'Invalid domain',
  'error.pullzone.hostname_already_registered': 'Domain already present',
  'error.pullzone.certificate_request_failed': 'Unable to generate SSL certificate. Please be sure your CNAME record is properly configured and the DNS zone is fully propagated',
  'EnableSsl.error': 'Unable to generate SSL certificate',
  'EnableSsl.success': 'HTTPS enabled.',
  'DisableSsl.success': 'HTTPS disabled',
  'Enable2FA.success': '2FA enabled succesfully',
  'Disable2FA.success': '2FA disabled',
  'EditCardInfo.submit': 'Save',

  'ChangePlan.plan': 'Please select your plan',
  'ChangePlan.recurrence': 'Recurrence',
  'ChangePlan.coupon': 'Coupon code',
  'ChangePlan.submit': 'Change plan',
};



// WEBPACK FOOTER //
// ./app/messages.js